var _tspan;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3Min(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 914 622",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M566.958 381.1h-542.4V86h97.5V33.9h347.3V86h97.5v295.1Zm-515.8-16.511h499.188V102.51h-97.5v-52.1H138.57v52.1h-97.5v262.078z",
    style: {
      opacity: 1,
      fill: "#a6b6ac",
      strokeWidth: 13.1504,
      strokeDasharray: "none"
    },
    transform: "matrix(1.58074 0 0 1.58074 -14.262 -19.687)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 109.146,
    y: 128.893,
    dx: -57.382,
    dy: -74.135,
    style: {
      fill: "#a6b6ac",
      fontFamily: "Arial,sans-serif",
      fontSize: 12,
      whiteSpace: "pre",
      InkscapeFontSpecification: "&quot",
      fontWeight: 400,
      fontStyle: "normal",
      fontStretch: "normal",
      fontVariant: "normal",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal"
    },
    transform: "matrix(13.8506 0 0 14.11189 -295.789 -382.05)"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", null, "3"))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 670.751,
    cy: 200.307,
    rx: 30.761,
    ry: 29.184,
    style: {
      fill: "#a6b6ac",
      stroke: "#a6b6ac",
      strokeWidth: 0.245669,
      strokeDasharray: "none",
      paintOrder: "fill"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 670.751,
    cy: 336.307,
    rx: 30.761,
    ry: 29.184,
    style: {
      fill: "#a6b6ac",
      stroke: "#a6b6ac",
      strokeWidth: 0.245669,
      strokeDasharray: "none"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Min);
export default __webpack_public_path__ + "static/media/3.min.ab94d193c272f86ae8ddfa8bd9b4fbbe.svg";
export { ForwardRef as ReactComponent };